export enum UserActionType {

  // Load
  LoadSingleUser                  = 'LOAD_SINGLE_USER',
  LoadSingleUserCompleted         = 'LOAD_SINGLE_USER_COMPLETED',
  LoadSingleUserFailed            = 'LOAD_SINGLE_USER_FAILED',

  LoadUserErgoTeam                  = 'LOAD_USER_ERGO_TEAM',
  LoadUserErgoTeamCompleted         = 'LOAD_USER_ERGO_TEAM_COMPLETED',
  LoadUserErgoTeamFailed            = 'LOAD_USER_ERGO_TEAM_FAILED',

  LoadUsers                       = 'LOAD_USERS',
  LoadUsersCompleted              = 'LOAD_USERS_COMPLETED',
  LoadUsersFailed                 = 'LOAD_USERS_FAILED',

  LoadDetailedUsers               = 'LOAD_DETAILED_USERS',
  LoadDetailedUsersCompleted      = 'LOAD_DETAILED_USERS_COMPLETED',
  LoadDetailedUsersFailed         = 'LOAD_DETAILED_USERS_FAILED',

  LoadAdminUsers                  = 'LOAD_ADMIN_USERS',
  LoadAdminUsersCompleted         = 'LOAD_ADMIN_USERS_COMPLETED',
  LoadAdminUsersFailed            = 'LOAD_ADMIN_USERS_FAILED',

  LoadUserFromLoggedInUser        = 'LOAD_USER_FROM_LOGGED_IN_USER',
  LoadUserFromLoggedInUserFailed  = 'LOAD_USER_FROM_LOGGED_IN_USER_FAILED',

  UserDetailRequest               = 'USER_DETAIL_REQUEST',
  UserDetailRequestRejected       = 'USER_DETAIL_REQUEST_REJECTED',

  // Update User
  UserUpdate                      = 'USER_UPDATE',
  UserUpdated                     = 'USER_UPDATED',
  UserUpdateFailed                = 'USER_UPDATE_FAILED',

  // Select
  SelectUser                      = 'SELECT_USER',
  SelectUserCompleted             = 'SELECT_USER_COMPLETED',
  SelectUserFailed                = 'SELECT_USER_FAILED',

  // Reset
  ResetSelectedUser               = 'RESET_SELECTED_USER',

  // Create
  CreateUser                      = 'CREATE_USER',
  CreateUserCompleted             = 'CREATE_USER_COMPLETED',
  CreateUserFailed                = 'CREATE_USER_FAILED',

  AddErgoTeamMember               = 'ADD_ERGO_TEAM_MEMBER',
  AddErgoTeamMemberCompleted      = 'ADD_ERGO_TEAM_MEMBER_COMPLETED',
  AddErgoTeamMemberFailed         = 'ADD_ERGO_TEAM_MEMBER_FAILED',

  // Delete
  DeleteUser                      = 'DELETE_USER',
  DeleteUserCompleted             = 'DELETE_USER_COMPLETED',
  DeleteUserFailed                = 'DELETE_USER_FAILED',

  RemoveErgoTeamMember            = 'REMOVE_ERGO_TEAM_MEMBER',
  RemoveErgoTeamMemberCompleted   = 'REMOVE_ERGO_TEAM_MEMBER_COMPLETED',
  RemoveErgoTeamMemberFailed      = 'REMOVE_ERGO_TEAM_MEMBER_FAILED',
}
